import { Tooltip } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNewTrialState } from "../../new-trail/hooks/NewTrialStateProvider";
import "../styles.less";
import { AUTOZONE_REQUEST_STATUS } from "../types";
import { formatTranslation } from "../../../shared/utils/translationUtils";
type TooltipType = "processing" | "generation";

interface TooltipProps {
  type: TooltipType;
  children?: React.ReactNode;
}
const ZoneTooltip: React.FC<TooltipProps> = ({ type, children }) => {
  const { autozoneRequestStatus } = useNewTrialState();
  return autozoneRequestStatus === AUTOZONE_REQUEST_STATUS.DEFAULT ? (
    <GenerationToolTip>{children}</GenerationToolTip>
  ) : (
    <ProcessingTooltip>{children}</ProcessingTooltip>
  );
};

// const ZoneTooltip: React.FC<TooltipProps> = ({ type, children }) => {
//   const {autozoneRequestStatus} = useNewTrialState();
//   return type === "processing" ? (
//     <ProcessingTooltip>{children}</ProcessingTooltip>
//   ) : (
//     <GenerationToolTip>{children}</GenerationToolTip>
//   );
// };

export default ZoneTooltip;

const ProcessingTooltip: React.FC<{ children?: React.ReactNode }> = ({
  children,
}) => {
  const { t } = useTranslation();
  return (
    <Tooltip
      className="autozone-tooltip"
      placement="leftTop"
      title={formatTranslation(t("autozones.tooltip.processing"))}
    >
      {children}
    </Tooltip>
  );
};

export const GenerationToolTip: React.FC<{ children?: React.ReactNode }> = ({
  children,
}) => {
  const { t } = useTranslation();
  return (
    <Tooltip
      className="autozone-tooltip"
      placement="leftTop"
      title={formatTranslation(t("autozones.tooltip.generation"))}
    >
      {children}
    </Tooltip>
  );
};
